import React from "react";
import CHIQ from "../assets/partners/CHIQ.png";
import GREE from "../assets/partners/GREE.png";
import Hisense from "../assets/partners/hisence.png";
import LG from "../assets/partners/LG.png";
import Midea from "../assets/partners/Midea.png";
import Samsung from "../assets/partners/samsung.png";
import Trane from "../assets/partners/tran.png";

const logos = [
  { name: "CHIQ",    image: CHIQ    },
  { name: "GREE",    image: GREE    },
  { name: "Hisense", image: Hisense },
  { name: "LG",      image: LG      },
  { name: "Midea",   image: Midea   },
  { name: "Samsung", image: Samsung },
  { name: "Trane",   image: Trane   },
];

const scrollStyles = `
  @keyframes scroll-left {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  .scroll-track {
    animation: scroll-left 18s linear infinite;
  }
  .scroll-track:hover {
    animation-play-state: paused;
  }

  /* On mobile: disable auto-scroll animation, enable finger scroll */
  @media (max-width: 639px) {
    .scroll-track {
      animation: none;
      transform: none;
    }
    .scroll-wrapper {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
    }
    .scroll-wrapper::-webkit-scrollbar {
      display: none;
    }
  }
`;

export default function BrandPartners() {
  return (
    <section className="bg-white py-10 sm:py-14 font-poppins overflow-hidden">
      <style>{scrollStyles}</style>

      {/* Title */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 mb-8 sm:mb-10">
        <div className="flex justify-center">
          <h2
            className="text-lg sm:text-4xl rounded-md font-extrabold text-white px-6 sm:px-12 py-3 tracking-widest text-center"
            style={{ backgroundColor: "#0F1030" }}
          >
            OUR BRAND PARTNERS
          </h2>
        </div>
      </div>

      {/* Scroll wrapper — finger scrollable on mobile, auto-scroll on desktop */}
      <div className="scroll-wrapper overflow-hidden w-full">
        <div
          className="scroll-track flex items-center w-max"
          style={{ gap: "clamp(24px, 5vw, 64px)", paddingLeft: "16px", paddingRight: "16px" }}
        >
          {/* Desktop: duplicate logos for seamless loop. Mobile: show once, scroll with fingers */}
          {[...logos, ...logos].map((b, i) => (
            <div
              key={i}
              className="flex-shrink-0 flex items-center justify-center"
              style={{ width: "clamp(80px, 12vw, 128px)" }}
            >
              <img
                src={b.image}
                alt={b.name}
                className="w-full h-auto object-contain transition-all duration-300"
                style={{ maxHeight: "clamp(40px, 6vw, 56px)" }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Mobile scroll hint */}
      <p className="text-center text-xs text-gray-400 mt-4 sm:hidden">
        ← Swipe to see all brands →
      </p>
    </section>
  );
}